export class ChartData {
    CreatedDate: Date;
    Referred: number;
    Positive: number;
}

export class DashboardData{
    TotalPatients: number;
    NCPLabs: number;
    NCPClinics: number;
    VocationalTrainingAttendees: number;
    Districts: number;
    AlliedProviders: number;
    Labs: number;
    Clinics: number;
    chartData: ChartData[];
}


export class GetDashboardDataDefault{
    districtId: any = 0;
    startDate: string;
    endDate: string;
    tehsilIds: any = "0";
    genderIds: any = "0";
    patientStatus:any
}
export class FOrDTC{
    districtId: any =localStorage.getItem("DTCDISTRICTID")
    startDate: string;
    endDate: string;
    tehsilIds: any = "0";
    genderIds: any = "0";
    patientStatus:any
}